"use client";
import { PolymorphicContext } from "../contexts/polymorphic/PolymorphicContext.js";
import "react/jsx-runtime";
import { useContext } from "react";
const usePolymorphic = () => {
  const ctx = useContext(PolymorphicContext);
  if (!ctx) {
    throw new Error(
      `usePolymorphic hook was called outside of context, make sureyour
	  app is wrapped with PolymorphicProvider component`
    );
  }
  return ctx.components;
};
export {
  usePolymorphic
};
